import clsx from 'clsx';
import styles from './IconLabelView.module.scss';

type IconLabelViewProps = {
  icon: React.ReactNode;
  label: string;
  wrapperClassName?: string;
  labelClassName?: string;
};

export const IconLabelView = (props: IconLabelViewProps) => {
  return (
    <div className={clsx(styles.wrapper, props.wrapperClassName)}>
      {props.icon}
      <div className={clsx(styles.label, props.labelClassName)}>
        {props.label}
      </div>
    </div>
  );
};
